import LoginBoxForRedirect from '../components/sections/Login/LoginBoxForRedirect';

export default function LoginForRedirect() {
  return (
    <div>
      <LoginBoxForRedirect />
    </div>
  );
}
